import React from 'react';
import { ShieldCheck, CheckCircle } from 'lucide-react';
import { SectionWrapper } from './ui/SectionWrapper';
export function Guarantee() {
  return <SectionWrapper background="slate" data-id="element-149">
      <div className="max-w-3xl mx-auto bg-emerald-50 border-2 border-emerald-200 rounded-2xl p-8 md:p-12 text-center" data-id="element-150">
        <div className="flex justify-center mb-6" data-id="element-151">
          <ShieldCheck className="h-16 w-16 text-emerald-600" data-id="element-152" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-emerald-900 mb-8" data-id="element-153">
          Nuestro compromiso contigo
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left" data-id="element-154">
          <div data-id="element-155">
            <h3 className="font-bold text-emerald-800 mb-4" data-id="element-156">
              Lo que SÍ garantizamos:
            </h3>
            <ul className="space-y-3" data-id="element-157">
              {['Contenido claro, organizado y en español', 'Pasos concretos, no teoría vaga', 'Herramientas, plantillas y checklists útiles', 'Información verificada y actualizada'].map((item, i) => <li key={i} className="flex items-start gap-2 text-emerald-900/80 text-sm" data-id="element-158">
                  <CheckCircle className="h-4 w-4 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-159" />
                  <span data-id="element-160">{item}</span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-161">
            <h3 className="font-bold text-slate-700 mb-4" data-id="element-162">
              Lo que NO garantizamos:
            </h3>
            <ul className="space-y-3" data-id="element-163">
              {['Resultados financieros específicos', 'Que Amazon no cambie sus políticas o tarifas', 'Éxito sin esfuerzo, investigación y adaptación'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-600 text-sm" data-id="element-164">
                  <span className="h-1.5 w-1.5 rounded-full bg-slate-400 flex-shrink-0 mt-2" data-id="element-165" />
                  <span data-id="element-166">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-emerald-200" data-id="element-167">
          <p className="text-xs text-emerald-800/60" data-id="element-168">
            No promovemos ni apoyamos prácticas que violen las políticas de
            Amazon o las leyes aplicables.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}